export const UPDATE_BUY_QUANTITY = 'redeem/UPDATE_BUY_QUANTITY'
export const UPDATE_PRODUCT = 'redeem/UPDATE_PRODUCT'
// export const UPDATE_STORE_ID_LIST = 'stores/UPDATE_STORE_ID_LIST'


export const UPDATE_BUY_REDEEMS = 'shoppingProgress/UPDATE_BUY_REDEEMS'

export const UPDATE_SHOPPING_COUNT = 'headerBar/UPDATE_SHOPPING_COUNT'